<template> 
  <div class="link"> 
 <a :href="'https://www.google.com/maps/search/?api=1&output=embed&query='+cData"  target="_blank">{{cData}}</a>

  </div> 
</template> 


<script>


export default {
  data () {
    return {
      data:{}
    }
  },
  computed: {
    cData () {
      return this.data.coordinates
    }
  }
}
</script>